module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-action-bar"
  }, [_c('div', {
    staticClass: "action-bar",
    class: {
      inverted: _vm.inverted
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "action"
  }, [_vm._t("action")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dc16a3a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ActionBar.vue
// module id = 2559
// module chunks = 1